<script setup lang="ts">
  import type { QuotedPlanVm } from '~/models/quoting/QuotedPlan'
  import QuoteCardFooter from '~/components/quote/card/QuoteCardFooter.vue'

  const props = defineProps<{
    quote: QuotedPlanVm
    stacked?: boolean
  }>()

  const { devModeEnabled, openInConnecture, isHeatEnabled } = DevModeHelpers.use()
</script>

<template>
  <div
    class="flex"
    :class="
      stacked
        ? 'mt-3 w-full justify-between'
        : 'mt-3 w-full justify-between md:mt-0 md:w-fit md:gap-6'
    "
  >
    <QuoteCardFooter :quote="quote" minimal stacked />
  </div>

  <aside
    v-if="devModeEnabled && isHeatEnabled(quote)"
    class="flex items-center justify-center gap-1.5 p-3"
    :class="{ 'absolute left-1/2 -translate-x-1/2': stacked }"
  >
    <HpIcon name="login" class="w-4 text-primary" />
    <HpAnchor class="text-sm font-bold" @click.prevent="openInConnecture(quote.externalId)">
      Open app in Connecture
    </HpAnchor>
  </aside>

  <QuoteCardSectionActionsButtons
    :class="stacked ? 'w-full' : 'w-full md:max-w-md'"
    :quote="quote"
  />
</template>

<style scoped></style>
